/* =====================================================================
   LATAKAN - guide.js  (page "Guide des tailles")
   Calculateur taille/poids + FAQ accordeon. Vanilla, autonome.
   ===================================================================== */
(function () {
  'use strict';
  var $ = function (s, c) { return (c || document).querySelector(s); };
  var $$ = function (s, c) { return [].slice.call((c || document).querySelectorAll(s)); };

  var SIZES = ['S', 'M', 'L', 'XL', 'XXL', '3XL', '4XL'];
  var HMAX = [170, 175, 180, 185, 190, 195];   // seuils de hauteur (<=) -> S..3XL, sinon 4XL
  var EXPW = [60, 68, 75, 82, 90, 98, 106];     // poids de reference par taille (cf. exemples)

  var hSel = $('#calcH'), wSel = $('#calcW');
  function fill(sel, from, to, def) {
    if (!sel) return;
    var html = '';
    for (var v = from; v <= to; v++) html += '<option value="' + v + '"' + (v === def ? ' selected' : '') + '>' + v + '</option>';
    sel.innerHTML = html;
  }
  fill(hSel, 150, 205, 180);
  fill(wSel, 40, 130, 75);

  function reco() {
    var h = +((hSel && hSel.value) || 180), w = +((wSel && wSel.value) || 75);
    var i = HMAX.length; // 4XL par defaut
    for (var k = 0; k < HMAX.length; k++) { if (h <= HMAX[k]) { i = k; break; } }
    if (i < SIZES.length - 1 && w >= EXPW[i] + 9) i++;   // poids eleve -> taille au-dessus
    if (i > 0 && w <= EXPW[i] - 12) i--;                  // poids faible -> taille en dessous
    return SIZES[i];
  }
  var lastSize = null;
  function update() {
    var out = $('#calcSize'); if (!out) return;
    var size = reco();
    out.textContent = size;
    if (size !== lastSize) {
      lastSize = size;
      var r = $('#calcRes');
      if (r && r.animate) r.animate([{ transform: 'scale(.985)' }, { transform: 'scale(1)' }], { duration: 220, easing: 'cubic-bezier(.22,.61,.36,1)' });
    }
  }
  update();
  if (hSel) { hSel.addEventListener('change', update); hSel.addEventListener('input', update); }
  if (wSel) { wSel.addEventListener('change', update); wSel.addEventListener('input', update); }

  // FAQ accordeon
  $$('#faq .gfaq__q').forEach(function (q) {
    q.addEventListener('click', function () {
      var item = q.parentNode, a = q.nextElementSibling;
      var open = item.classList.toggle('is-open');
      a.style.maxHeight = open ? (a.scrollHeight + 'px') : '0px';
    });
  });
})();
